import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreStringifiedArray } from '../../ParseHelper';
import { LevelType, IPlayerLevelData } from '../../../State/Player/Progress/PlayerLevels';

type PlayerStateKey = 'levels';
type PlayerDataKeys = 'stars' | 'friendHelperAttempts' | 'v2_44_2_levelAttempts';

export default class Levels implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        const stars = playerStateData.levels[LevelType.Core].map(levelData => levelData.stars);
        const helperFriendAttempts = playerStateData.levels[LevelType.Core].map(
            levelData => levelData.helperFriendAttempts
        );
        const levelAttempts = playerStateData.levels[LevelType.Core].map(levelData => levelData.attempts);

        return (
            playerEndpointData.stars !== JSON.stringify(stars) ||
            playerEndpointData.friendHelperAttempts !== JSON.stringify(helperFriendAttempts) ||
            playerEndpointData.v2_44_2_levelAttempts !== JSON.stringify(levelAttempts)
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        const stars = restoreStringifiedArray<number>(playerEndpointData.stars, []);
        const friendHelperAttempts = restoreStringifiedArray<number>(playerEndpointData.friendHelperAttempts, []);
        const levelAttempts = restoreStringifiedArray<number>(playerEndpointData.v2_44_2_levelAttempts, []);

        return {
            [LevelType.Core]: stars.map<IPlayerLevelData>((stars, index) => {
                return {
                    levelNumber: index + 1,
                    stars,
                    helperFriendAttempts: friendHelperAttempts[index] || 0,
                    // If stored attempts aren't found and level has been completed, backfill with 1 attempt
                    attempts: levelAttempts[index] ?? stars > 0 ? 1 : 0,
                };
            }),
        };
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        const stars = playerStateData.levels[LevelType.Core].map(levelData => levelData.stars);
        const friendHelperAttempts = playerStateData.levels[LevelType.Core].map(
            levelData => levelData.helperFriendAttempts
        );
        const levelAttempts = playerStateData.levels[LevelType.Core].map(levelData => levelData.attempts);
        return {
            stars: JSON.stringify(stars),
            friendHelperAttempts: JSON.stringify(friendHelperAttempts),
            v2_44_2_levelAttempts: JSON.stringify(levelAttempts),
        };
    }
}
